import { render } from "./OrdersFilter.vue?vue&type=template&id=71b55292"
import script from "./OrdersFilter.vue?vue&type=script&lang=js"
export * from "./OrdersFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__